import './LiveboardSpinner.style.less'

import loading from '@/assets/lottie/data.json'
import lottie from 'lottie-web'
import { useEffect } from 'react'

function LiveboardSpinner(props: { width?: number }) {
  const selector = Math.floor(Math.random() * 1000)
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector(`#react-logo-${selector}`) as any,
      animationData: loading,
      renderer: 'svg', // "canvas", "html"
      loop: true, // boolean
      autoplay: true, // boolean
    })
  }, [])

  return (
    <div className="loading-spinner">
      <div
        id={`react-logo-${selector}`}
        style={{ width: props.width ?? 400, height: props.width ?? 400 }}
      />
    </div>
  )
}

export default LiveboardSpinner
